import React, {useState} from "react";

const BeforeAfterSlider = ({ beforeImg, afterImg, title }) => {
    const [sliderPosition, setSliderPosition] = useState(50);
  
    const handleSliderChange = (e) => {
      setSliderPosition(e.target.value);
    };
  
    return (
      <div className="flex flex-col items-center">
        {/* Title removed as it's now handled in the parent component */}
        <div className="relative w-full h-64 overflow-hidden rounded-t-lg">
          {/* After Image (Full) */}
          <div className="absolute inset-0">
            <img 
              src={afterImg} 
              alt="After" 
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Before Image (Clipped) */}
          <div 
            className="absolute inset-0"
            style={{
              clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
            }}
          >
            <img 
              src={beforeImg} 
              alt="Before" 
              className="w-full h-full object-cover"
            />
          </div>
  
          {/* Slider Line */}
          <div 
            className="absolute inset-0 w-1 bg-white cursor-ew-resize"
            style={{ left: `${sliderPosition}%` }}
          >
            {/* Slider Handle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center cursor-ew-resize border-2 border-teal-500">
              <div className="flex space-x-1">
                <div className="w-0.5 h-4 bg-teal-500"></div>
                <div className="w-0.5 h-4 bg-teal-500"></div>
              </div>
            </div>
          </div>
  
          {/* Labels */}
          <div className="absolute bottom-4 left-4 px-3 py-1 bg-lime-500 text-white text-sm rounded-full font-medium shadow-sm">
            Before
          </div>
          <div className="absolute bottom-4 right-4 px-3 py-1 bg-teal-600 text-white text-sm rounded-full font-medium shadow-sm">
            After
          </div>
  
          {/* Hidden Range Input for Accessibility */}
          <input
            type="range"
            min="0"
            max="100"
            value={sliderPosition}
            onChange={handleSliderChange}
            className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
            aria-label="Before/After comparison slider"
          />
        </div>
      </div>
    );
};

export default BeforeAfterSlider;